import { useState } from 'react';

export default function FloatingWhatsApp() {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="fixed bottom-20 md:bottom-6 right-4 md:right-6 z-30 flex flex-col items-end gap-2">
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 ${
          showTooltip
            ? 'opacity-100 translate-y-0 scale-100'
            : 'opacity-0 translate-y-2 scale-95 pointer-events-none'
        }`}
      >
        <div className="bg-foreground-800 text-background-50 text-xs font-label font-medium px-3 py-1.5 rounded-lg shadow-lg whitespace-nowrap">
          Chat with us!
        </div>
      </div>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/919686543847?text=Hey%20Joviaa!%20I%20need%20help%20choosing%20the%20right%20jewellery"
        target="_blank"
        rel="nofollow noopener noreferrer"
        className="whatsapp-float group relative flex items-center justify-center w-14 h-14 rounded-full cursor-pointer shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 active:scale-95 z-30"
        style={{ backgroundColor: '#25D366' }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onTouchStart={() => {
          setShowTooltip(true);
          setTimeout(() => setShowTooltip(false), 2000);
        }}
        aria-label="Chat on WhatsApp"
      >
        {/* Pulse rings */}
        <span className="whatsapp-pulse-ring absolute inset-0 rounded-full" style={{ backgroundColor: '#25D366' }}></span>
        <span className="whatsapp-pulse-ring-2 absolute inset-0 rounded-full" style={{ backgroundColor: '#25D366' }}></span>

        {/* Icon */}
        <div className="w-7 h-7 flex items-center justify-center relative z-10">
          <i className="ri-whatsapp-fill text-2xl text-white"></i>
        </div>
      </a>
    </div>
  );
}